module.exports = __webpack_public_path__ + "static/img/assisted1.5ff8b6b1.png";